export default __webpack_public_path__ + "assets/algeria-flag.png";